import { useTranslation } from 'react-i18next';
import { useNavigationStore } from '@/store/useNavigationStore';

import logoMymEs from '@/assets/img/logos/logo-mym-es.svg';
import logoMymEu from '@/assets/img/logos/logo-mym-eu.svg';

function MymLinkList({ links, className }) {
    if (!links.length) return null;
    return (
        <ul className={className}>
            {links.map((link) => (
                <li key={link.id}>
                    <a href={link.iri} target="_blank" rel="noopener noreferrer">
                        {link.title}
                    </a>
                </li>
            ))}
        </ul>
    );
}

export default function MymDropdown({ drawer = false }) {
    const { t, i18n } = useTranslation();
    const links = useNavigationStore((s) => s.mymLinks);
    const logo = i18n.language === 'eu' ? logoMymEu : logoMymEs;

    if (drawer)
        return (
            <nav
                className="drawer--mym is-hidden-desktop flow--l"
                aria-label={t('otras exposiciones')}
            >
                <img src={logo} alt="mujer y memoria" />
                <MymLinkList
                    links={links}
                    className="list-reset link-dn is-size-6 has-text-weight-medium is-flex is-flex-direction-column"
                />
            </nav>
        );

    return (
        <nav className="mym-dropdown" aria-label={t('otras exposiciones')}>
            <details>
                <summary>
                    <div className="mym-logo">
                        <img src={logo} alt="mujer y memoria" />
                    </div>
                </summary>
                <MymLinkList links={links} className="list-reset link-dn" />
            </details>
        </nav>
    );
}
